"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/cascader/style/css");

var _cascader = _interopRequireDefault(require("antd/es/cascader"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./thread.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  TextArea
} = _input.default;
const {
  confirm
} = _modal.default;
const {
  Item
} = _form.default;

function filter(inputValue, path) {
  return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 : false);
}

class NewThreadListItem extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isUnsaved: false,
      confirmLoading: false
    };
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleOk = async () => {
      if (this.form.current) {
        const form = this.form.current;
        const {
          createThread,
          close
        } = this.props;
        await form.validateFields().then(async () => {
          const {
            title,
            body,
            participant
          } = form.getFieldsValue();
          this.setState({
            confirmLoading: true
          });
          await createThread({
            title,
            body,
            participantId: parseInt(participant[0])
          }).then(() => {
            this.setState({
              isUnsaved: false,
              confirmLoading: false
            });
            close();
          });
        });
      }
    };

    this.handleCancel = () => {
      const {
        close
      } = this.props;

      if (this.state.isUnsaved) {
        confirm({
          title: 'Are you sure you want to delete this message?',
          content: '',
          okText: 'Delete',
          okType: 'danger',
          onOk: () => {
            close();
          },

          onCancel() {}

        });
      } else {
        close();
      }
    };

    this.onChange = () => {
      this.setState({
        isUnsaved: true
      });
    };
  }

  render() {
    const {
      visible,
      participants
    } = this.props;
    const {
      confirmLoading
    } = this.state;

    const options = _lodash._.map(participants, participant => _lodash._.pick(participant, ['username', 'id'])).map(option => {
      return {
        label: option.username,
        value: option.id.toString()
      };
    });

    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      destroyOnClose: true,
      closable: false,
      centered: true,
      title: "Compose Message",
      visible: visible,
      okText: "Send Message",
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      confirmLoading: confirmLoading
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "thread-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "participant",
      label: "Participant:",
      rules: [{
        required: true,
        message: 'Participant is required.'
      }]
    }, /*#__PURE__*/_react.default.createElement(_cascader.default, {
      placeholder: "Enter participant's username",
      options: options,
      onChange: this.onChange,
      showSearch: {
        filter
      }
    })), /*#__PURE__*/_react.default.createElement(Item, {
      name: "title",
      label: "Title:",
      rules: [{
        required: true,
        message: 'Title is required.'
      }, {
        max: 50,
        message: 'Exceeds 50 character limit.'
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Enter thread title",
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      name: "body",
      label: "Message:",
      rules: [{
        required: true,
        message: 'Message body is required.'
      }]
    }, /*#__PURE__*/_react.default.createElement(TextArea, {
      placeholder: "Type a message",
      autoSize: {
        minRows: 2,
        maxRows: 6
      },
      onChange: this.onChange
    }))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  participants: selectors.getRequestedStudyParticipantsWithUsernames
});

var _default = (0, _reactRedux.connect)(mapStateToProps)(NewThreadListItem);

exports.default = _default;